import qrcode from 'qrcode-generator';
import { useMemo } from 'react';
import { safeInviteLink } from '../domain/invite';

const BOT_LINK = /^https:\/\/t\.me\/pass24app_bot(\/dev)?$/;

/**
 * QR drawn locally — the link is never sent to a QR service. Only a clean invite link or our bot's own
 * link is drawn; anything else renders nothing.
 */
export function QrCode({ value, size = 240, label = 'QR-код ссылки для гостя' }: { value: string; size?: number; label?: string }) {
  const safe = BOT_LINK.test(value) ? value : safeInviteLink(value);
  const drawing = useMemo(() => {
    if (!safe) return null;
    const qr = qrcode(0, 'M');
    qr.addData(safe);
    qr.make();
    const count = qr.getModuleCount();
    let d = '';
    for (let r = 0; r < count; r++) for (let c = 0; c < count; c++) if (qr.isDark(r, c)) d += `M${c} ${r}h1v1h-1z`;
    return { count, d };
  }, [safe]);

  if (!drawing) return null;
  const quiet = 4;
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`${-quiet} ${-quiet} ${drawing.count + quiet * 2} ${drawing.count + quiet * 2}`}
      shapeRendering="crispEdges"
      style={{ background: '#fff', borderRadius: 16 }}
    >
      <path d={drawing.d} fill="#000" />
    </svg>
  );
}
